export const chargingAmountWarning =
  "Bitte beachten Sie, dass es sich bei der Lademenge lediglich um eine Hochrechnung handelt, " +
  "falls kein separater Zähler für die Wallbox an den Energieimpuls angeschlossen ist, " +
  "da abhängig vom Modell Ihrer Wallbox die geladene Menge und der tatsächliche  " +
  "Ladestrom nicht ausgelesen werden können.";
export const chargingHistoryTitle = "Ladevorgänge";
export const chargingHistoryHelp =
  "In der Ladehistorie können Sie die Ladevorgänge Ihres E-Autos einsehen. " +
  chargingAmountWarning;

export const chargingHistoryExport = "Ladehistorie als Exceldatei exportieren:";
